// React
import React, { Component } from "react";
// Translations
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
// Styles
import "components/Accordion/styles/styles.scss";
// Components
import { Divider } from "@material-ui/core";
import {
  Button,
  Input,
  SelectAutocomplete,
  SelectSimple,
} from "@components/Input";
import { handleCopy } from "vendor/application";
import Tooltip from "@components/Tooltip";
import { returnElementFromArray } from "vendor/application";
// SVG
import { closeSvg, copySvg, deleteSvg } from "assets";
import CentrideskCustomField from "components/Accordion/AccordionIntents/params/centridesk_custom_field";
import {
  getCentrideskIntegration,
  getVariableDeskCentridesk,
  setVariableDeskCentridesk,
} from "components/Accordion/AccordionIntents/params/centridesk_custom_field_helpers";

/**
 *
 * @typedef {import('types/ident').IdentVariable} IdentVariable
 * @typedef {{
 *  variables: IdentVariable[]
 *  updateVariables(variables: IdentVariable[]): void
 * }} Props
 *
 *
 * @augments {Component<Props>}
 */
class Variables extends Component {
  /**
   * @param {Props} props
   */
  constructor(props) {
    super(props);
    this.state = {
      showComponents: false,
      selectedDeskId: null,
      extensionsSelected: [],
    };
  }
  toggleComponents = () => {
    this.setState((prevState) => ({
      showComponents: !prevState.showComponents,
    }));
  };
  componentDidMount = () => {
    this.getSuncoCustomFields();
  };

  componentDidUpdate = (prevProps) => {
    const { integrations } = this.props;
    if (prevProps.integrations !== integrations) {
      this.getSuncoCustomFields();
    }
  };

  integrationSunco() {
    const { integrations } = this.props;
    if (!integrations) {
      return null;
    }
    return integrations?.find((int) => int.channel === "sunco");
  }

  integrationZendesk() {
    const { integrations } = this.props;
    if (!integrations) {
      return null;
    }
    return integrations?.find((int) => int.channel === "zendesk_full");
  }
  getDeskIdZendesk = () => {
    const integration_zendesk = this.integrationZendesk();
    const zendeskId = integration_zendesk?.channel_id;
    return zendeskId || this.state.selectedDeskId;
  };

  getDeskId() {
    const integration_sunco = this.integrationSunco();
    const suncoId = integration_sunco?.channel_id;

    return suncoId || this.state.selectedDeskId;
  }

  getSuncoCustomFields = () => {
    const {
      intent,
      use_custom_fields,
      getCustomFields,
      integrations,
      i,
      updateIntent,
    } = this.props;
    const integration_zendesk_full = integrations?.filter(
      (int) => int.channel === "zendesk_full"
    )[0];

    var use_custom = integration_zendesk_full?.multiple.filter(
      (int) => int.use_custom_fields
    );

    if (use_custom?.length === 1) {
      var new_desk_id = use_custom[0].id;
      if (intent.extensions?.variables_desk) {
        if (
          intent.extensions.variables_desk[i] &&
          intent.extensions.variables_desk[i].zendesk_ticket_field
        ) {
          intent.extensions.variables_desk[i].zendesk_ticket_field.desk_id =
            new_desk_id;
        }
      }
      updateIntent(intent);
      if (!use_custom_fields || !use_custom_fields[new_desk_id]) {
        getCustomFields("zendesk", new_desk_id, intent);
      }
    }

    const integration_sunco = this.integrationSunco();
    if (integration_sunco?.info?.zendesk?.use_custom_fields?.active) {
      const desk_id = integration_sunco.channel_id;
      if (!use_custom_fields || !use_custom_fields[desk_id]) {
        getCustomFields("sunco", desk_id, intent);
      }
    }
  };

  updateVariable = (e, type, i) => {
    const { variables, updateVariables, updateIntent, intent } = this.props;
    if (type === "variable") {
      const oldName = "$." + variables[i].variable;
      const newName = "$." + e.target.value;

      const entry =
        intent.extensions.variables_desk &&
        intent.extensions.variables_desk.find((v) => v.name === oldName);
      if (entry) entry.name = newName;

      variables[i].variable = e.target.value;

      updateIntent(intent);
      updateVariables(variables);
    }
  };

  addVariable = () => {
    const { variables, updateVariables, updateIntent, intent } = this.props;
    variables.push({
      variable: "",
      equivalence: [],
      zendesk_ticket_field: {
        desk_id: null,
        id: null,
        title: "",
        type: "",
        equivalences: [],
        custom_field_options: [],
        custom_field_options_actual: [],
      },
    });

    updateVariables(variables);
    updateIntent(intent);
  };

  deleteVariable = (e, i) => {
    const { variables, intent, updateVariables, updateIntent } = this.props;
    const { extensionsSelected } = this.state;

    let { variables_desk } = intent.extensions;

    variables.splice(i, 1);
    variables_desk?.splice(i, 1);

    if (Array.isArray(extensionsSelected)) {
      extensionsSelected.splice(i, 1);
      this.setState({ extensionsSelected });
    }

    updateVariables(variables);
    updateIntent(intent);
  };

  updateEquivalence = (e, variable_pos, equivalence_pos, type) => {
    const { variables, updateVariables, updateIntent, intent } = this.props;
    variables[variable_pos].equivalence[equivalence_pos][type] = e.target.value;
    updateVariables(variables);
    updateIntent(intent);
  };

  addEquivalence = (e, i) => {
    const { variables, updateVariables } = this.props;
    variables[i].equivalence.push([{ key: "", value: "" }]);
    updateVariables(variables);
  };

  deleteTicketField = (i) => {
    const { variables, updateVariables } = this.props;
    const newVariables = [...variables];
    newVariables[i].zendesk_ticket_field = null;
    updateVariables(newVariables);
  };

  deleteEquivalence = (e, variable_pos, equivalence_pos) => {
    const { variables, updateVariables } = this.props;
    variables[variable_pos].equivalence.splice(equivalence_pos, 1);
    updateVariables(variables);
  };

  handleParameters = (e, type, i) => {
    const { variables, updateVariables } = this.props;

    const variable = variables[i];

    const newVariables = [...variables];
    const desk_id = variable?.zendesk_ticket_field?.desk_id;
    newVariables[i].zendesk_ticket_field = {
      id: e.id,
      type: e.type,
      title: e.title,
      equivalences: [],
      desk_id,
      custom_field_options: e.custom_field_options ?? [],
      custom_field_options_actual: e.custom_field_options
        ? JSON.parse(JSON.stringify(e.custom_field_options))
        : [],
    };
    updateVariables(newVariables);
  };

  updateCentrideskVariable = (i, mapping) => {
    const { variables, intent, updateIntent } = this.props;
    intent.extensions.variables_desk = setVariableDeskCentridesk(
      intent.extensions.variables_desk,
      "$." + variables[i].variable,
      mapping
    );
    updateIntent(intent);
  };

  handleExtensions = (e, type, i, deskIdProps) => {
    const { variables, updateVariables, intent, updateIntent, integrations } =
      this.props;
    const suncoIntegration = this.integrationSunco();
    const zendeskIntegration = integrations?.filter(
      (int) => int.channel === "zendesk_full"
    )[0];
    const validIdZendeskUnique =
      zendeskIntegration && integrations?.length === 1;
    const deskId = validIdZendeskUnique
      ? integrations[0]?.id
      : intent.extensions?.variables_desk?.[i]?.zendesk_ticket_field?.desk_id;
    const index = zendeskIntegration?.multiple?.findIndex(
      (desk) => desk.id === deskId
    );
    const newValueDeskId = deskIdProps.zendesk_ticket_field?.desk_id || deskId;

    let desk_id = null;
    if (suncoIntegration) {
      desk_id = this.getDeskId();
    } else if (zendeskIntegration) {
      desk_id =
        newValueDeskId ??
        integrations?.[0]?.multiple?.[i]?.id ??
        integrations?.[0]?.multiple?.[index]?.id ??
        null;
    }

    if (!e || !desk_id) {
      return;
    }
    const options = {
      id: e.id,
      type: e.type,
      title: e.title,
      equivalences: [],
      desk_id,
      custom_field_options: e.custom_field_options ?? [],
      custom_field_options_actual: e.custom_field_options
        ? JSON.parse(JSON.stringify(e.custom_field_options))
        : [],
    };

    const variable = variables[i];
    variable.zendesk_ticket_field = options;

    const { variables_desk } = intent.extensions;

    /**
     * @type {Map<string, import('types/zendesk').ZendeskVariable>}
     */
    const ticketFieldByVariableName = new Map(
      (variables_desk || [])
        .filter((variable_desk) => !!variable_desk)
        .map((variable_desk) => [variable_desk.name, variable_desk])
    );

    const name = "$." + variable.variable;

    ticketFieldByVariableName.set(name, {
      ...(ticketFieldByVariableName.get(name) || {}),
      name,
      zendesk_ticket_field: options,
    });

    intent.extensions.variables_desk = Array.from(
      ticketFieldByVariableName.values()
    );

    updateIntent(intent);
    updateVariables(variables);
  };

  addParameterEquivalence = (i) => {
    const { variables, updateVariables, intent, updateIntent } = this.props;
    if (!variables[i].zendesk_ticket_field.equivalences) {
      variables[i].zendesk_ticket_field.equivalences = [];
    }
    variables[i].zendesk_ticket_field.equivalences.push({
      text: "",
      value: "",
      title: "",
    });
    if (
      intent.extensions.variables_desk?.[i] &&
      !intent.extensions.variables_desk[i].zendesk_ticket_field
    ) {
      intent.extensions.variables_desk[i].zendesk_ticket_field = {};
    }
    intent.extensions.variables_desk = intent.extensions.variables_desk || [];
    if (!intent.extensions.variables_desk[i]) {
      intent.extensions.variables_desk[i] = { zendesk_ticket_field: {} };
    }
    intent.extensions.variables_desk[i].zendesk_ticket_field.equivalences = [
      ...variables[i].zendesk_ticket_field.equivalences,
    ];

    updateIntent(intent);
    updateVariables(variables);
  };

  updateParameterEquivalence = (e, variable, equivalence) => {
    const { variables, updateVariables } = this.props;
    if (variables[variable].zendesk_ticket_field.equivalences[equivalence]) {
      variables[variable].zendesk_ticket_field.equivalences[equivalence].text =
        e.target.value;
    }
    updateVariables(variables);
  };

  /**
   * @param {{ name: string; value: number }} e
   * @param {{
   *  equivalenceIndex: number;
   *  variableIndex: number;
   * }} indexes
   */

  getZendeskTicketFieldByVariableName = (variableName) => {
    const { intent } = this.props;
    return (
      intent.extensions?.variables_desk?.find(
        (v) => v.name === `$.${variableName}`
      )?.zendesk_ticket_field || null
    );
  };

  selectParameterEquivalence = (e, indexes) => {
    const { variableIndex, equivalenceIndex } = indexes;
    const { variables, updateVariables } = this.props;

    const variable = variables[variableIndex];
    const ticketField = variable.zendesk_ticket_field;
    if (!ticketField) return;

    const equivalences =
      ticketField.equivalences?.length > 0 ? ticketField.equivalences : [];

    const all_custom_field =
      ticketField.custom_field_options?.length > 0
        ? [...ticketField.custom_field_options]
        : [
            ...(this.getDeskFieldByVariable(variable.variable)
              ?.custom_field_options || []),
          ];

    let actual_custom_field =
      ticketField.custom_field_options_actual?.length > 0
        ? [...ticketField.custom_field_options_actual]
        : [
            ...(this.getDeskFieldByVariable(variable.variable)
              ?.custom_field_options_actual || []),
          ];

    const usedOptions = equivalences.map((eq) => eq.value).filter(Boolean);
    const allValues = all_custom_field.map((opt) => opt.value);

    if (usedOptions.includes(e.value)) return;

    if (usedOptions.length >= allValues.length) return;

    const currentEquivalence = equivalences[equivalenceIndex];
    if (currentEquivalence?.value && currentEquivalence.value !== e.value) {
      const prevOption = returnElementFromArray(
        currentEquivalence.value,
        all_custom_field,
        "value"
      );
      if (
        prevOption &&
        !actual_custom_field.some((opt) => opt.value === prevOption.value)
      ) {
        actual_custom_field.push(prevOption);
      }
    }
    actual_custom_field = actual_custom_field.filter(
      (opt) => opt.value !== e.value
    );
    if (!currentEquivalence) {
      return;
    }

    currentEquivalence.value = e?.value;
    currentEquivalence.title = e?.name;
    const uniqueOptions = actual_custom_field.filter(
      (opt, idx, self) => self.findIndex((o) => o.value === opt.value) === idx
    );

    ticketField.custom_field_options_actual = uniqueOptions;
    variable.zendesk_ticket_field = ticketField;
    variables[variableIndex] = variable;

    updateVariables([...variables]);
  };

  deleteParameterEquivalence = (variable, equivalence) => {
    const { variables, updateVariables, updateIntent, intent } = this.props;
    const { extensionsSelected } = this.state;
    const variableObj = variables?.[variable];

    if (!variableObj?.zendesk_ticket_field) return;

    const ticketField = variableObj.zendesk_ticket_field;

    const equivalences =
      ticketField.equivalences?.length > 0 ? ticketField.equivalences : [];

    const all_custom_field =
      ticketField.custom_field_options?.length > 0 &&
      ticketField.custom_field_options.length > 0
        ? ticketField.custom_field_options
        : Array.isArray(
            this.getDeskFieldByVariable(variableObj.variable)
              ?.custom_field_options
          )
        ? this.getDeskFieldByVariable(variableObj.variable).custom_field_options
        : [];

    const actual_custom_field =
      ticketField.custom_field_options_actual?.length > 0 &&
      ticketField.custom_field_options_actual.length > 0
        ? ticketField.custom_field_options_actual
        : Array.isArray(
            this.getDeskFieldByVariable(variableObj.variable)
              ?.custom_field_options_actual
          )
        ? this.getDeskFieldByVariable(variableObj.variable)
            .custom_field_options_actual
        : [];
    if (equivalences?.[equivalence]?.value) {
      const element = returnElementFromArray(
        equivalences[equivalence].value,
        all_custom_field,
        "value"
      );

      if (
        element &&
        !actual_custom_field.find((el) => el.value === element.value)
      ) {
        actual_custom_field.push(element);
      }
    }

    if (equivalences.length > equivalence) {
      equivalences.splice(equivalence, 1);
    }
    if (Array.isArray(extensionsSelected)) {
      extensionsSelected.splice(equivalence, 1);
      this.setState({ extensionsSelected });
    }

    ticketField.equivalences = equivalences;
    ticketField.custom_field_options = all_custom_field;
    ticketField.custom_field_options_actual = actual_custom_field;
    variableObj.zendesk_ticket_field = ticketField;
    variables[variable] = variableObj;

    updateVariables([...variables]);
    const name = "$." + variableObj.variable;
    const variablesDeskMap = new Map(
      (intent.extensions.variables_desk || [])
        .filter((v) => !!v)
        .map((v) => [v.name, v])
    );
    variablesDeskMap.set(name, {
      name,
      zendesk_ticket_field: {
        ...ticketField,
        custom_field_options: all_custom_field,
        custom_field_options_actual: actual_custom_field,
      },
    });

    intent.extensions.variables_desk = Array.from(variablesDeskMap.values());
    updateIntent(intent);
  };

  shouldShowCustomFieldSelector = () => {
    const { integrations } = this.props;

    if (integrations.length > 0) {
      const integration = integrations.find(
        (int) => int.channel === "zendesk_full"
      );

      if (!integration) return false;

      const use_custom = integration?.multiple.filter(
        (int) => int.use_custom_fields
      );
      if (!use_custom) return false;

      if (use_custom?.length === 1) {
        return true;
      }
      if (use_custom?.length > 1) {
        return true;
      }
    }
    return false;
  };
  updateDeskId = (deskId, i, elId) => {
    const {
      intent,
      getCustomFields,
      use_custom_fields,
      updateVariables,
      updateIntent,
      variables,
      type,
    } = this.props;

    const newVariables = [...variables];
    if (!newVariables[i].zendesk_ticket_field) {
      newVariables[i].zendesk_ticket_field = {};
    }
    newVariables[i].zendesk_ticket_field = {
      desk_id: deskId,
      id: null,
      type: "",
      title: "",
      equivalences: [],
      custom_field_options: [],
      custom_field_options_actual: [],
    };

    const name = "$." + newVariables[i].variable;
    const variablesDeskMap = new Map(
      (intent.extensions.variables_desk || [])
        .filter((v) => !!v)
        .map((v) => [v.name, v])
    );
    const newZendeskTicketField = {
      ...newVariables[i].zendesk_ticket_field,
      id: elId,
      type: type,
      title: intent.name,
      equivalences: [],
      desk_id: deskId,
    };
    this.setState({
      extensionsSelected: [
        newZendeskTicketField,
        ...(this.state.extensionsSelected || []),
      ],
    });
    variablesDeskMap.set(name, {
      name,
      zendesk_ticket_field: newZendeskTicketField,
    });

    intent.extensions.variables_desk = Array.from(variablesDeskMap.values());

    updateVariables(newVariables);
    updateIntent(intent);

    if (!use_custom_fields || !use_custom_fields[deskId]) {
      getCustomFields("zendesk", deskId, intent);
    }
  };

  getDeskFieldByVariable = (variableName) => {
    const { intent } = this.props;
    return intent?.extensions?.variables_desk?.find(
      (v) => v.name === `$.${variableName}`
    )?.zendesk_ticket_field;
  };

  getFilteredCustomFieldOptions = (variable, currentEquivalences, currentIndex) => {
    const allOptions = variable.zendesk_ticket_field?.custom_field_options_actual?.length > 0
      ? variable.zendesk_ticket_field.custom_field_options_actual
      : this.getDeskFieldByVariable(variable.variable)?.custom_field_options_actual || [];
    const usedValues = currentEquivalences
      .map((eq, idx) => idx !== currentIndex ? eq.value : null)
      .filter(Boolean);
    return allOptions.filter(option => !usedValues.includes(option.value));
  };

  render() {
    const { use_custom_fields, t, variables, integrations, intent } =
      this.props;
    const validSuncoIntegration = this.integrationSunco();
    const suncoDeskId = validSuncoIntegration ? this.getDeskId() : null;
    const validZendeskIntegration = this.integrationZendesk();
    const zendeskDeskId = validZendeskIntegration
      ? this.getDeskIdZendesk()
      : null;

    return (
      <div className={"accordion__element_variables"}>
        <div className={"accordion__element_header"}>
          <span>
            {t("intents.config.accordion.extensions.content.variables.title")}{" "}
            <Tooltip
              text={t(
                "intents.config.accordion.extensions.content.variables.description"
              )}
            />
          </span>
        </div>
        <div className={"accordion__element_content"}>
          {variables?.map((el, i) => {
            const integration = integrations.find(
              (int) => int.channel === "zendesk_full"
            );

            const desk_id = integration
              ? el?.zendesk_ticket_field?.desk_id ?? null
              : suncoDeskId ?? null;

            let zendesk_options = [];

            if (desk_id && use_custom_fields?.[desk_id]) {
              const deskOptions = use_custom_fields[desk_id] || [];

              if (deskOptions.length > 0) {
                zendesk_options = deskOptions;
              } else if (typeof deskOptions === "object") {
                zendesk_options =
                  Object.values(deskOptions).find((val) =>
                    Array.isArray(val)
                  ) || [];
              }
            }
            const has_zendesk = zendesk_options?.length > 0;

            // const integrationExists = integrations?.some((int) =>
            //   int?.multiple?.some(
            //     (d) => d.id === el?.zendesk_ticket_field?.desk_id
            //   )
            // );

            const zendesk_options_title_map = zendesk_options.map((option) => ({
              ...option,
              title: `${option.title} ${
                option.regexp_for_validation
                  ? `(${option.regexp_for_validation})`
                  : ""
              }`,
            }));
            const zendesk_ticket_field = el?.zendesk_ticket_field ?? {};
            const showZendeskTicketField =
              zendesk_ticket_field?.type === "tagger" &&
              (zendesk_ticket_field?.custom_field_options?.length > 0 ||
                zendesk_ticket_field?.custom_field_options_actual?.length > 0 ||
                true);

            var desk_name = "-";
            if (el.zendesk_ticket_field && el.zendesk_ticket_field.desk_id) {
              desk_name = integration?.multiple?.filter(
                (int) => int.id === el.zendesk_ticket_field.desk_id
              )[0]?.name;
            }

            const deskId = zendesk_ticket_field?.desk_id ?? null;
            const allOptions =
              Array.isArray(zendesk_ticket_field.custom_field_options) &&
              zendesk_ticket_field.custom_field_options.length > 0
                ? zendesk_ticket_field.custom_field_options
                : this.getDeskFieldByVariable(el.variable)?.custom_field_options
                    ?.length > 0
                ? this.getDeskFieldByVariable(el.variable).custom_field_options
                : use_custom_fields?.[deskId]
                ? intent?.extensions?.variables_desk?.[0]?.zendesk_ticket_field
                    ?.custom_field_options ?? []
                : [];

            const currentEquivalences =
              el.zendesk_ticket_field?.equivalences || [];
            const options = allOptions || [];

            const isMaxReached = currentEquivalences.length >= options.length;

            const selectedOption = (() => {
              const validOptions = zendesk_options_title_map;
              const currentId = el?.zendesk_ticket_field?.id;
            
              const isValid = validOptions.some((opt) => opt.id === currentId);
              return isValid
                ? validOptions.find((opt) => opt.id === currentId)
                : null;
            })();

            return (
              <div
                className={"accordion__element_variable"}
                key={`variable_${i}`}
              >
                <div className={"accordion__element_variable_header"}>
                  <div className={"accordion__element_variable_header_content"}>
                    <span>$.</span>
                    <Input
                      type={"transparent"}
                      className={`${el.error ? "error" : ""}`}
                      placeholder={t(
                        "intents.config.accordion.extensions.content.variables.variable.name"
                      )}
                      inputProps={{ "aria-label": "description" }}
                      value={el.variable}
                      onChange={(e) => {
                        this.updateVariable(e, "variable", i);
                      }}
                    />
                  </div>
                  <div className={"accordion__element_variable_header_actions"}>
                    <div onClick={() => handleCopy(`$.${el.variable}`)}>
                      {copySvg()}
                    </div>
                    <div
                      onClick={(e) => {
                        this.deleteVariable(e, i);
                      }}
                    >
                      {deleteSvg()}
                    </div>
                  </div>
                </div>
                <div className={"accordion__element_variable_content"}>
                  {el.equivalence &&
                    el.equivalence.length > 0 &&
                    el.equivalence.map((equivalence, equivalence_pos) => {
                      return (
                        <React.Fragment key={`equivalence_${equivalence_pos}`}>
                          <div
                            className={
                              "accordion__element_variable_content_equivalences"
                            }
                          >
                            <Input
                              onChange={(e) => {
                                this.updateEquivalence(
                                  e,
                                  i,
                                  equivalence_pos,
                                  "key"
                                );
                              }}
                              value={equivalence.key ? equivalence.key : ""}
                              placeholder={t(
                                "intents.config.accordion.extensions.content.variables.variable.key"
                              )}
                              className={"secondary"}
                              inputProps={{ maxLength: 4096 }}
                            />
                            <Input
                              onChange={(e) => {
                                this.updateEquivalence(
                                  e,
                                  i,
                                  equivalence_pos,
                                  "value"
                                );
                              }}
                              value={equivalence.value ? equivalence.value : ""}
                              placeholder={t(
                                "intents.config.accordion.extensions.content.variables.variable.value"
                              )}
                              className={"secondary"}
                              inputProps={{ maxLength: 4096 }}
                            />
                            <div
                              className={"platform_input_content_delete"}
                              onClick={(e) => {
                                this.deleteEquivalence(e, i, equivalence_pos);
                              }}
                            >
                              {deleteSvg()}
                            </div>
                          </div>
                          {equivalence_pos !== el.equivalence.length - 1 && (
                            <Divider />
                          )}
                        </React.Fragment>
                      );
                    })}
                  <>
                    <Button
                      type={"dashed"}
                      onClick={(e) => {
                        this.addEquivalence(e, i);
                      }}
                      text={t(
                        "intents.config.accordion.extensions.content.variables.variable.add"
                      )}
                    />
                  </>
                  {this.shouldShowCustomFieldSelector() && (
                    <div className={"accordion__element_use_custom_fields"}>
                      <SelectSimple
                        valueSelected={desk_name}
                        items={integration?.multiple}
                        label={t("common:intents.integrations.desk_id")}
                        onSelect={(e) => {
                          this.updateDeskId(e, i, el?.zendesk_ticket_field?.id);
                        }}
                        placeholder={t("common:intents.integrations.desk_id")}
                        value={"id"}
                        className={"select_secondary"}
                        t={t}
                      />
                    </div>
                  )}

                  {has_zendesk && (
                    <>
                      <div
                        className={"accordion__element_variable_content_custom"}
                      >
                        <div className={"accordion__element_use_custom_fields"}>
                          {getCentrideskIntegration(integrations) && (
                            <span className={"accordion__element_use_custom_fields_label"}>
                              {t("intents.config.accordion.params.zendesk_custom_field.label")}
                            </span>
                          )}
                          <div className={"actions"}>
                            <SelectAutocomplete
                              value={selectedOption}
                              searchOption={"title"}
                              items={zendesk_options_title_map}
                              className={"select_secondary"}
                              onSelect={(e, type) => {
                                this.handleExtensions(e, type, i, el);
                              }}
                              placeholder={t(
                                "intents.config.accordion.params.zendesk_custom_field.custom_field"
                              )}
                              iteration={i}
                              t={t}
                            />
                            <Button
                              className={"btn_icon"}
                              type={"white"}
                              onClick={() => {
                                this.deleteTicketField(i);
                              }}
                              text={closeSvg()}
                            />
                          </div>
                        </div>
                      </div>
                      <>
                        {showZendeskTicketField && (
                          <>
                            <Button
                              disabled={isMaxReached}
                              type={"dashed"}
                              onClick={() => {
                                this.addParameterEquivalence(i);
                              }}
                              text={t(
                                "intents.config.accordion.params.zendesk_custom_field.add_button"
                              )}
                            />
                            {currentEquivalences?.map(
                              (equivalence, equivalenceIndex) => {
                                return (
                                  <div
                                    className={
                                      "accordion__element_parameter_equivalence"
                                    }
                                    key={equivalenceIndex}
                                  >
                                    <Input
                                      id={`equivalences-${equivalenceIndex}`}
                                      onChange={(e) => {
                                        this.updateParameterEquivalence(
                                          e,
                                          i,
                                          equivalenceIndex
                                        );
                                      }}
                                      value={equivalence.text}
                                      placeholder={t(
                                        "intents.config.accordion.params.zendesk_custom_field.text"
                                      )}
                                    />
                                    <SelectSimple
                                      valueSelected={
                                        equivalence.title
                                          ? equivalence.title
                                          : "-"
                                      }
                                      items={this.getFilteredCustomFieldOptions(el, currentEquivalences, equivalenceIndex)}
                                      className={"select_secondary"}
                                      onSelect={(event) =>
                                        this.selectParameterEquivalence(event, {
                                          variableIndex: i,
                                          equivalenceIndex: equivalenceIndex,
                                        })
                                      }
                                      placeholder={t(
                                        "intents.config.accordion.params.zendesk_custom_field.value"
                                      )}
                                      iteration={[i, equivalenceIndex]}
                                      t={t}
                                    />
                                    <div
                                      onClick={() =>
                                        this.deleteParameterEquivalence(
                                          i,
                                          equivalenceIndex
                                        )
                                      }
                                      className={"delete_equivalence"}
                                    >
                                      {closeSvg()}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </>
                        )}
                      </>
                    </>
                  )}
                  {el.variable && (
                    <div className={"accordion__element_variable_content_custom"}>
                      <CentrideskCustomField
                        showLabel={has_zendesk}
                        closeIcon={closeSvg}
                        integrations={integrations || []}
                        mapping={getVariableDeskCentridesk(intent.extensions?.variables_desk, "$." + el.variable)}
                        onChange={(mapping) => this.updateCentrideskVariable(i, mapping)}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          <Button
            type={"dashed"}
            onClick={(e) => {
              this.addVariable(e);
            }}
            text={t(
              "intents.config.accordion.extensions.content.variables.button"
            )}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const accordion_variables = connect(mapStateToProps)(Variables);

export default withTranslation("common")(accordion_variables);